export default "__VITE_ASSET__a907a9ea__"